import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  font-family: Sora;
  width: 280px;
  min-height: 150px;
  background: #f5f5f5;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px,
    rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  padding: 10px;

  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: ${(props) => (props.isAbove ? "-27px" : "auto")};
    top: ${(props) => (props.isAbove ? "auto" : "-27px")};
    left: ${(props) => props.markPosition || "calc(50% - 14px)"};
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
    border-top: 14px solid
      ${(props) => (props.isAbove ? "#f5f5f5" : "transparent")};
    border-bottom: 14px solid
      ${(props) => (props.isAbove ? "transparent" : "#f5f5f5")};
  }
`;

export const Header = styled.div`
  margin: 16px 10px 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 21px;
    width: 21px;
  }
  path {
    stroke: #fff !important;
  }
  span {
    margin-left: 12px;

    font-size: 18px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
  }
`;

export const Description = styled.p`
  font-size: 12px;
  margin: 12px 10px 0 10px;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  color: #7e858f;
`;
export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
`;

export const TimerInput = styled.input`
  width: 150px;
  height: 34px;
  outline: none;
  border: 0.941243px solid #d4d6da;
  border-radius: 5.64746px;

  font-size: 12px;
  padding-left: 10px;

  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.87);
  }

  &:focus {
    border: 1px solid #40e5a0;
  }
`;

export const Label = styled.span`
  color: #42464c;
  font-family: Sora;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  margin-left: 9px;
`;

export const EdgesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 150px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background: #118052;
    width: 10px;
    border-radius: 6px;
  }
`;
